import SurveyFeedbackModal from './SurveyFeedbackModal';

export default SurveyFeedbackModal;
